import RegistrationProfileEntity, { IRegistrationProfileEntityAttributes } from './RegistrationProfileEntity';

export interface ISpgRegistrationProfileEntityAttributes {
	// Custom name of the registration profile specifically for this SPG
	customName?: string;
	// Legacy ID of this SPG registration profile
	legacyId: number;
	// The registration profile this association refers to
	registrationProfile: RegistrationProfileEntity | IRegistrationProfileEntityAttributes;
}

/**
 * Associates a registration profile with an SPG, including the SPG-specific custom name.
 * Not persisted to the database — data comes from Brownfield.
 */
export default class SpgRegistrationProfileEntity implements ISpgRegistrationProfileEntityAttributes {
	
	public customName?: string;
	
	public legacyId: number;
	
	public registrationProfile: RegistrationProfileEntity;

	constructor(attributes?: Partial<ISpgRegistrationProfileEntityAttributes>) {
		if (attributes) {
			if (attributes.customName !== undefined) {
				this.customName = attributes.customName;
			}
			if (attributes.legacyId !== undefined) {
				this.legacyId = attributes.legacyId;
			}
			if (attributes.registrationProfile !== undefined) {
				if (attributes.registrationProfile instanceof RegistrationProfileEntity) {
					this.registrationProfile = attributes.registrationProfile;
				} else {
					this.registrationProfile = new RegistrationProfileEntity(attributes.registrationProfile);
				}
			}
		}
	}

	public absoluteName() {
		return this.customName ?? this.registrationProfile?.name ?? "";
	}

	public isGrantorOnly() {
		return !!this.registrationProfile?.hasGrantors && !this.registrationProfile.hasSerialisedVehicle && !this.registrationProfile.hasSerialisedWatercraft;
	}
}